import type { Map } from 'mapbox-gl';

const loadRasterImage = (map: Map, id: string, url: string, options?: { sdf?: boolean }) => {
  return new Promise<void>((resolve, reject) => {
    if (map.hasImage(id)) {
      return resolve();
    }

    map.loadImage(url, (error, image) => {
      if (error || !image) {
        console.error(`Failed to load raster image: ${id}`, error);

        return reject(error);
      }

      if (!map.hasImage(id)) {
        map.addImage(id, image, options);
      }

      resolve();
    });
  });
};

export default loadRasterImage;
